import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import Content from '../components/Content';
import { getBookQuotes, setQuotesSourceBook } from '../services/api';
import {
  Box, Button,
  IconButton,
  LinearProgress, Link, Paper,
  Typography
} from '@material-ui/core';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Book from '../components/quotes/Book';
import List from '../components/quotes/List';
import BookSelector from '../components/quotes/BookSelector';

const Quotes = ({ userStore }) => {
  const { id } = useParams();
  const navigator = useNavigate();

  const [book, setBook] = useState(null);
  const [quotes, setQuotes] = useState(null);
  const [selectedQuotes, setSelectedQuotes] = useState([]);
  const [migrated, setMigrated] = useState([]);

  const onSave = async (book) => {
    if (selectedQuotes.length > 0 && book) {
      await setQuotesSourceBook(userStore.token, book.book_id, selectedQuotes)
      const m = selectedQuotes.map(quoteId => ({id: quoteId, bookId: book.book_id}))
      setMigrated(m);
    }
  }

  useEffect(() => {
    getBookQuotes(id, userStore.token).then(response => {
      setQuotes(response.data.data.quotes);
      setBook(response.data.data.book);
    });
  }, []);

  if (!book) {
    return (<LinearProgress />);
  }

  const clearSelection = () => {
    setSelectedQuotes([]);
  }

  const selectAll = () => {
    const select = [];
    quotes.map(quote => select.push(quote.id));
    setSelectedQuotes(select);
  }

  return (
    <Content  userStore={userStore} title='Trechos' customMenu={<Button color='inherit'
      onClick={() => navigator("/app/books")}
    >Voltar</Button>}>
      {book && <Book book={book} quotes={quotes} />}
      <br />
      <Paper style={{padding: '10px'}}>
        <Typography>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box>
              {selectedQuotes.length > 0 ?
                <IconButton onClick={() => clearSelection()}><HighlightOffIcon /></IconButton> :
                <IconButton onClick={() => selectAll()}><CheckCircleOutlineIcon /></IconButton>
              }
            </Box>
            <Box sx={{flexGrow: 1}}>
              {selectedQuotes.length > 0 ? `${selectedQuotes.length} trechos seleciondados` : 'Nenhum trecho selecionado'}
            </Box>
            <Box>
              <BookSelector userStore={userStore} onSave={onSave} />
            </Box>
          </Box>
        </Typography>
      </Paper>
      <br />
      <List quotes={quotes} selectedList={selectedQuotes} migrated={migrated}
            handleChange={(quoteId) => {
              const index = selectedQuotes.indexOf(quoteId);

              if (index < 0) {
                setSelectedQuotes([...selectedQuotes, quoteId]);
              } else {
                const newSelectedList = selectedQuotes.filter(item => item !== quoteId);
                setSelectedQuotes(newSelectedList);
              }
            }} />
    </Content>
  );
};

Quotes.propTypes = {
  bookStore: PropTypes.object,
  userStore: PropTypes.object
};

export default Quotes;
